import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'active-custom-tags',
  templateUrl: 'active-custom-tags.html',
})

export class ActiveCustomTagsCommponent {
  @Input() activeTags = [];
}


// WEBPACK FOOTER //
// ./src/components/active-custom-tags/active-custom-tags.ts